<template>
  <div
    class="
      media-grid
      critical-component-clear
    "
    :class="[
      {
        [$class('hidden')]: isMobile ?
          section.hideMobile : section.hideDesktop,
        'media-grid--half': halfWidth,
      },
      `section-content--${section.contentColor}`
    ]"
    :style="`--media-grid-bg: ${section.backgroundColor};`"
  >
    <div
      v-if="section.titleText"
      class="media-grid__title text-desktop-16-uc-desktop text-mobile-16-uc-mobile"
      v-html="section.titleText"
    />

    <div
      v-if="displayItems"
      class="media-grid__grid"
      :class="[
        section.gridClass && section.gridClass,
        section.layout && `media-grid__grid--${section.layout}`,
        {
          [`media-grid__grid--${section.layout}-half`]: halfWidth,
        },
      ]"
    >
      <template
        v-for="(item, index) of displayItems"
        :key="`media-grid__item-${index}`"
      >
        <component
          :is="element(item)"
          v-if="item?.blockSettings"
          :href="item.blockSettings?.url"
          class="media-grid__item media-grid__item--media"
          :class="[
            {
              [$class('hidden')]: isMobile ?
                item.blockSettings.hideMobile : item.blockSettings.hideDesktop },
          ]"
        >
          <media-content
            :component-settings="{
              layout: item.blockSettings.mediaLayout,
              hasContent: false,
            }"
            block-class="media-grid"
            :mobile-media-settings="item.mobileMediaSettings"
            :desktop-media-settings="item.desktopMediaSettings"
            content-placement="half"
            parent="media-grid__item--media"
            @carousel-image-loaded="removePlaceholders"
          />
          <div
            v-if="item.blockSettings.titleText"
            class="
              media-grid__item-text"
          >
            <p
              v-if="
                item.blockSettings.url"
            >
              <span
                class="text-light"
                v-text="item.blockSettings.titleText"
              />
              <icon-chevron-right-special />
              <span
                class="media-grid__item-link text-regular"
                v-text="item.blockSettings.buttonText"
              />
            </p>

            <p
              v-else
            >
              <span
                class="text-light"

                v-text="item.blockSettings.titleText"
              />
            </p>
          </div>
        </component>
      </template>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Media grid (media-grid)
 * -----------------------------------------------------------------------------
 * Grid component displaying media items.
 *
 * @param {Object} section - Section settings.
 * @param {Array} items - Items to be displayed in grid.
 * @param {Boolean} halfWidth - Condition indicating if the component
 * should occupy half width.
 *
 */
import { mapState } from 'vuex'
import IconChevronRightSpecial from '~icons/direction/chevron/right-special.svg'
import MediaContent from '~async/media-content/media-content'

export default {
  name: 'MediaGrid',

  components: {
    MediaContent,
    IconChevronRightSpecial,
  },

  props: {
    section: {
      type: Object,
      default: () => ({
        backgroundColor: '',
        contentColor: '',
        gridClass: '',
        hideDesktop: false,
        hideMobile: false,
        id: '',
        layout: '',
        titleText: '',
      }),
    },
    items: {
      type: Array,
      default: () => [],
    },
    halfWidth: {
      type: Boolean,
      default: false,
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Compute items to display in grid
     * @returns {Boolean|String}
     */
    displayItems() {
      if (!this.items?.length) {
        return false
      }

      return this.items

    },
  },

  methods: {

    /**
     * Compute element type.
     * @returns {String}
     */
    element(item) {
      return item.blockSettings.url
        ? 'a'
        : 'div'
    },

    /**
     * Removes the liquid placeholders AFTER the vue media has loaded
     * and fully rendered.
     */
    removePlaceholders() {
      this.$nextTick().then(() => {
        const parent = this.$el.closest('section')
        const placeholder = parent.querySelector('.liquid-removed')
        if (!placeholder) {
          return
        }

        placeholder.remove()
      })
    },
  },
}
</script>

<style lang="scss">
@import './media-grid';
</style>
